<template>
  <products-base-view status="draft"></products-base-view>
</template>

<script>
import ProductsBaseView from "@/components/products/ProductsBaseView";
export default {
  name: 'DraftProductsView',
  inheritAttrs: false,
  components: {ProductsBaseView},
};
</script>
